// extracted by mini-css-extract-plugin
export default {"graphs_container":"SubSystemGraph_graphs_container__hR3x+"};